var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntityCompensation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n        opacity: .4;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #7da267;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.26,
    y: 82.68,
    width: 76.12,
    height: 28.96,
    rx: 11.2,
    ry: 11.2,
    transform: "translate(35.79 -56.13) rotate(16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.28,24.67c-25.01,4.9-41.31,29.16-36.41,54.17,4.9,25.01,29.16,41.31,54.17,36.41,25.01-4.9,41.31-29.16,36.41-54.17s-29.16-41.31-54.17-36.41ZM130.23,103.11c-17.85,3.5-35.15-8.13-38.65-25.98-3.5-17.85,8.13-35.15,25.98-38.65,17.85-3.5,35.15,8.13,38.65,25.98,3.5,17.85-8.13,35.15-25.98,38.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.16,
    y: 79.38,
    width: 14.13,
    height: 12.16,
    transform: "translate(37.1 -51.85) rotate(18.91)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.75,59.66h29.49l-14.75-8.14-14.75,8.14ZM111.84,66.69v14.06h5.62v-14.06h-5.62ZM121.68,66.69v14.06h5.62v-14.06h-5.62ZM131.53,66.69v14.06h5.62v-14.06h-5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.51,47.27c-.63-.35-1.41-.35-2.04,0l-19.93,10.99c-1.13.62-1.74,1.89-1.49,3.2.27,1.42,1.55,2.42,2.99,2.42h38.96c1.65,0,3-1.34,3-3,0-1.09-.59-2.09-1.55-2.62l-19.94-10.99ZM124.5,51.53l14.75,8.14h-29.49l14.75-8.14ZM111.84,66.69h-4.22v14.06h-1.22c-.37,0-.72.17-.95.46-1.44,1.78-.22,3.76,1.47,3.76h35.67c.37,0,.72-.17.95-.46,1.44-1.78.22-3.76-1.47-3.76h-.7v-14.06h-4.22v14.06h-5.62v-14.06h-4.22v14.06h-5.62v-14.06h-4.22v14.06h-5.62v-14.06ZM104.15,92h40.69c1.12,0,2.07-.85,2.14-1.96.08-1.24-.89-2.26-2.1-2.26h-40.77c-1.22,0-2.19,1.02-2.1,2.26.07,1.11,1.03,1.96,2.14,1.96Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntityCompensation);
export default __webpack_public_path__ + "static/media/entity_compensation.905c8612c92f1009a81aa615d81c83e4.svg";
export { ForwardRef as ReactComponent };